var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLoadmore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-loadmore",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.9 33.9",
    style: {
      enableBackground: "new 0 0 33.9 33.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.icon-loadmore .st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,30.1l1.6-12.6l10.1,7.6l-3.9,1.7c2.6,2.5,6.2,3.9,9.9,3.7c5.7-0.3,10.6-4.1,12.2-9.6l3.2,1 c-2.1,6.8-8.2,11.6-15.3,11.9c-0.3,0-0.6,0-0.9,0c-4.9,0-9.4-2.1-12.6-5.7L0,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,16.3L22.2,8.6L26.1,7c-2.6-2.4-6.1-3.8-9.8-3.6C10.5,3.7,5.6,7.6,4,13.1l-3.2-1C2.8,5.2,8.9,0.4,16.1,0 c5.2-0.3,10,1.9,13.4,5.6l4.4-1.9L32.3,16.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLoadmore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_loadmore.8e7214ea.svg";
export { ForwardRef as ReactComponent };